export const useUserInfo = () => {
  return useStatefulCookie<User.Info>('userInfo')
}

export const usePremiumExpiredAt = () => {
  return useStatefulCookie<number>('premiumExpiredAt')
}

export const useUserBadge = () => {
  return useStatefulCookie<Badge.Item[]>('userBadge')
}
